export const scenarioHandlers = {
  knownCustomer: ({ currentCustomer }) => !!currentCustomer,
  newCustomer: ({ currentCustomer }) => !currentCustomer,
  remoteEvent: ({ event }) => (event || {}).isRemote,
  showGuests: ({ event, price }) => {
    const { numberOfSeatsAvailable, guestLimit, isFree } = event;
    const canHaveGuests =
      numberOfSeatsAvailable > 1 && (!guestLimit || guestLimit > 0);
    if (isFree) {
      return canHaveGuests;
    }
    return price && (price.isTable || canHaveGuests);
  }
};



// WEBPACK FOOTER //
// ./src/App/events/Views/Detail/RegistrationCard/RegistrationForm/FieldConfig/utils.js